import React from 'react';

export const CopayIcon: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			aria-labelledby=""
			className={className}
			viewBox="0 0 40 64"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeMiterlimit="10"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M16.7054 63.0303C15.5148 61.3436 13.9273 58.1687 12.9847 52.9598C12.2406 48.991 9.11524 33.1162 9.11524 33.1162C8.61916 31.3799 9.76016 29.1475 12.0422 28.4034C14.8203 27.5104 17.2015 29.3956 17.6976 30.7846L23.9483 46.5106M35.1103 61.4925L38.186 43.4845C38.4837 41.6985 39.0294 39.1685 37.3427 37.2338L25.7342 23.3433M23.1545 38.8709H24.6924C25.2877 38.8709 25.7838 38.3748 25.7838 37.7795V2.06112C25.7838 1.46581 25.2877 0.969727 24.6924 0.969727H2.6661C2.0708 0.969727 1.57471 1.46581 1.57471 2.06112V37.7795C1.57471 38.3748 2.0708 38.8709 2.6661 38.8709H7.47815" />
		</svg>
	);
};
